import {ReactElement} from "react";
import PanoramaVerticalIcon from "@mui/icons-material/PanoramaVertical";
import SportsRugbyIcon from "@mui/icons-material/SportsRugby";
import PowerIcon from "@mui/icons-material/Power";
import CableIcon from "@mui/icons-material/Cable";
import DialpadIcon from "@mui/icons-material/Dialpad";
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import DiamondIcon from '@mui/icons-material/Diamond';
import StarIcon from '@mui/icons-material/Star';

const iconNameToIcon: Record<string, ReactElement> = {
    standartCuff: <PanoramaVerticalIcon />,
    bigCuff: <PanoramaVerticalIcon />,
    bulbs: <SportsRugbyIcon />,
    adapters: <PowerIcon />,
    connectors: <CableIcon />,
    others: <DialpadIcon />,
    ADMIN: <AdminPanelSettingsIcon sx={{ color: "red"}} />,
    OPT: <StarIcon sx={{ color: "orange"}} />,
    SUPEROPT: <DiamondIcon sx={{ color: "blue"}}/>,
};

export { iconNameToIcon };
